import { canCallApp, config, isApp, user } from '../utils';
import { track } from '../tracking/bi';

// Data models tracking (BI & Zendesk)
import { TmpFilterResetBIModel } from '../BI/models';

// If cat-native-filters-ios end in ROLLBACK, remove the following function
const setNativeFilters = () => {
    if ( !isApp() ) {
         return;
    }
    document.querySelectorAll( '.js-open-native-filters' ).forEach( ( btn ) => {
        btn.addEventListener( 'click', ( e ) => {
            e.preventDefault();
            if ( canCallApp( 'openNativeFiltersV3' ) ) {
                Trendier.openNativeFiltersV3( JSON.stringify(config.currentSearchFilters) );
            } else if ( canCallApp( 'openFilters' ) ) {
                Trendier.openFilters();
            }
        } );
    } );
};

const resetFiltersEvent = () => {
    const ANDROID_PLATFORM = 'android';
    if ( isApp && ( config.platform ?? '' ).toLowerCase() === ANDROID_PLATFORM ) {
        const resetButtons = document.querySelectorAll( '#filter-mobile-form input[type="reset"]' );
        resetButtons.forEach( btn => {
            const tmpFilterResetBIModel = new TmpFilterResetBIModel(user?.id);
            btn.addEventListener( 'click', () => track(tmpFilterResetBIModel));
        });
    }
};

export { setNativeFilters, resetFiltersEvent };
